/*
<div data-count-up="1">
  <div class="counter-value js-count-up" data-parent-id="1" data-target="24.5" data-decimals="1">0.0%</div>
  <div class="counter-value js-count-up" data-parent-id="1" data-target="12500" data-decimals="0" data-suffix=" pt" data-use-comma="true">0 pt</div>
  <div class="counter-value js-count-up custom-anim" data-parent-id="1" data-target="950" data-decimals="0" data-progress-var="--my-progress" data-suffix="人">0人</div>
</div>
 */
export default class CountUp {
  constructor(element, options = {}) {
    const parentId = element.dataset.parentId ?? null

    this.element = element
    this.parent = parentId ? document.querySelector(`[data-count-up="${parentId}"]`) : element
    // HTMLの data-target 属性から目標値を取得（設定がない場合は0）
    this.targetValue = parseFloat(this.element.dataset.target) || 0

    // 小数点以下の桁数を設定 (優先順位: data属性 > 引数 > デフォルト1)
    if (this.element.hasAttribute('data-decimals')) {
      this.decimals = parseInt(this.element.dataset.decimals, 10)
    } else if (options.decimals !== undefined) {
      this.decimals = options.decimals
    } else {
      this.decimals = 0
    }

    // CSS変数名を設定 (優先順位: data属性 > 引数 > デフォルト'--progress')
    if (this.element.hasAttribute('data-progress-var')) {
      this.progressVar = this.element.dataset.progressVar
    } else if (options.progressVar !== undefined) {
      this.progressVar = options.progressVar
    } else {
      this.progressVar = '--progress'
    }

    // サフィックス(単位)を設定 (優先順位: data属性 > 引数 > デフォルト'%')
    if (this.element.hasAttribute('data-suffix')) {
      this.suffix = this.element.dataset.suffix
    } else if (options.suffix !== undefined) {
      this.suffix = options.suffix
    } else {
      this.suffix = ''
    }

    // カンマ区切りの設定 (優先順位: data属性 > 引数 > デフォルトfalse)
    if (this.element.hasAttribute('data-use-comma')) {
      this.useComma = this.element.dataset.useComma === 'true'
    } else if (options.useComma !== undefined) {
      this.useComma = !!options.useComma
    } else {
      this.useComma = false
    }

    this.isAnimating = false
    this.lastText = '' // 前回の表示内容を保持して差分検知に使用

    // ループを開始するメソッド
    this.startLoop = () => {
      if (!this.isAnimating) {
        this.isAnimating = true
        window.requestAnimationFrame(() => this.loop())
      }
    }

    // ループを停止するメソッド
    this.stopLoop = () => {
      this.isAnimating = false
      this.updateDisplay() // 最終値を確実にセット
    }

    // --- アニメーションやトランジションの開始・終了を検知してループを制御 ---
    // CSSアニメーション用
    this.parent.addEventListener('animationstart', this.startLoop)
    this.parent.addEventListener('animationiteration', this.startLoop)
    this.parent.addEventListener('animationend', this.stopLoop)
    this.parent.addEventListener('animationcancel', this.stopLoop)

    // CSSトランジション用 (transitionで変化させる場合にも対応)
    this.parent.addEventListener('transitionstart', this.startLoop)
    this.parent.addEventListener('transitionend', this.stopLoop)
    this.parent.addEventListener('transitioncancel', this.stopLoop)

    // 初期状態を反映し、初回ループを起動
    this.updateDisplay()
    this.startLoop()
  }

  // 表示を更新するメソッド
  updateDisplay() {
    // 指定されたCSS変数名で計算中の進行度 (0〜1) を取得
    const computedStyle = getComputedStyle(this.element)
    const progress = parseFloat(computedStyle.getPropertyValue(this.progressVar)) || 0

    // 目標値 * 進行度 で現在の数値を計算
    const currentValue = this.targetValue * progress

    // 数値のフォーマット (カンマ区切りの有無と小数点以下の桁数)
    let formattedValue
    if (this.useComma) {
      // toLocaleStringを使用してカンマ区切りと小数点桁数を指定
      formattedValue = currentValue.toLocaleString('en-US', {
        minimumFractionDigits: this.decimals,
        maximumFractionDigits: this.decimals,
      })
    } else {
      // toFixedを使用して小数点桁数のみ指定
      formattedValue = currentValue.toFixed(this.decimals)
    }

    const nextText = formattedValue + this.suffix

    // 表示内容が前回と変化した場合のみDOMを更新 (パフォーマンス最適化)
    if (this.lastText !== nextText) {
      this.element.textContent = nextText
      this.lastText = nextText
    }
  }

  // 描画ループ
  loop() {
    this.updateDisplay()
    if (this.isAnimating) {
      window.requestAnimationFrame(() => this.loop())
    }
  }
}
